



































































import Vue from "vue";
import Component from "vue-class-component";

@Component({
})
export default class TheModalState extends Vue {
    get modalState() {
        return this.$store.getters.modalState
    }
    set modalState(val) {
        val ? this.$store.commit('modal:open') : this.$store.commit('modal:close')
    }

    get imageState() {
        return this.$store.getters.imageState
    }
    set imageState(val) {
        val ? this.$store.commit('image:show') : this.$store.commit('image:hide')
    }

    get snackbarState() {
        return this.$store.getters.snackbarState
    }
    set snackbarState(val) {
        val ? this.$store.commit('snackbar:open') : this.$store.commit('snackbar:close')
    }
}
